"use client";
import { useEffect } from "react";
import { useSearchParams } from "next/navigation";

import { useStore, observer } from "../../service/mobx";
import { useTrackView } from "../../component/Hooks";
import { entityMap } from "../../component/Search/Hooks";
import { menuOptionsPublisher } from "../../component/Menu/menus/Search/Publisher";
import { menuOptionsTime } from "../../component/Menu/menus/Search/Time";
import {
  menuOptionsSortPaper,
  menuOptionsSortModel
} from "../../component/Menu/menus/Search/Sort";

function HooksSearch() {
  const { bottomSheet, search, tasks } = useStore();
  const searchParams = useSearchParams();

  useTrackView("Search");

  useEffect(() => {
    // after unmount, clean up
    return () => {
      search.reset();

      if (bottomSheet.open) {
        bottomSheet.set.open(false);
      }
    };
  }, [bottomSheet, search]);

  useEffect(() => {
    search.set.searchParams(searchParams);
  }, [search, searchParams]);

  const paramQ = searchParams.get("q") || undefined;

  useEffect(() => {
    search.set.userInput(paramQ);
  }, [search, paramQ]);

  const paramType = searchParams.get("type") || undefined;

  useEffect(() => {
    const type = extractValue(paramType, entityMap);

    search.set.filterType(type);
  }, [search, paramType]);

  const paramTime = searchParams.get("time") || undefined;

  useEffect(() => {
    const time = extractValue(paramTime, menuOptionsTime);

    search.set.filterTime(time);
  }, [search, paramTime]);

  const paramSort = searchParams.get("sort") || undefined;

  useEffect(() => {
    const sort = extractValue(
      paramSort,
      paramType === "models" ? menuOptionsSortModel : menuOptionsSortPaper
    );

    search.set.filterSort(sort);
  }, [search, paramType, paramSort]);

  const paramPublisher = searchParams.get("publisher") || undefined;

  useEffect(() => {
    const publisher = extractValue(paramPublisher, menuOptionsPublisher);

    search.set.filterPublisher(publisher);
  }, [search, paramPublisher]);

  const paramTask = searchParams.getAll("task");

  useEffect(() => {
    if (tasks._set.size && tasks._setModel.size) {
      const taskSet = new Set();

      for (const task of paramTask) {
        if (tasks._set.has(task) || tasks._setModel.has(task)) {
          taskSet.add(task);
        }
      }

      search.set.filterTask(taskSet);
    }
  }, [search, tasks._set, tasks._setModel, paramTask]);

  // const notLoadingSearchResultsFirst =
  //   firstLoad && searchParams.has("type") === false;

  // useEffect(() => {
  //   if (notLoadingSearchResultsFirst) {
  //     search.set.loadingResults(false);
  //   }

  //   setFirstLoad(false);
  // }, [search, notLoadingSearchResultsFirst]);
}

export default observer(HooksSearch);

function extractValue(urlValue, obj) {
  const value = urlValue?.toLowerCase();

  if (value) {
    const acceptedValues = new Set(Object.keys(obj));

    return acceptedValues.has(value) ? value : undefined;
  }
}

export function SetTrendingHook({ trending }) {
  const { search } = useStore();

  useEffect(() => {
    const { models, papers, tasks, videos } = trending;

    search.set.suggestedModels(models);
    search.set.suggestedPapers(papers);
    search.set.suggestedTasks(tasks);
    search.set.suggestedVideos(videos);
  }, [search, trending]);
}
